<template>
  <b-overlay
    opacity="0.75"
    spinner-variant="primary"
    :show="$root.$data.bsLoader"
  >
    <div class="edit-user-profile">
      <!-- navbar -->
      <nav-bar />

      <div class="user-settings">
        <!-- sidebar-->
        <div class="change-details">
          <tabs-bar></tabs-bar>
        </div>

        <!-- form -->
        <div class="user-form">
          <a href="#!" class="menu" @click="opensidebar()"
            ><i class="fas fa-bars fa-2x"></i
          ></a>
          <div
            class="work-session pt-4 pb-5 p-4"
            style="
              background-color: #ffffff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
            "
          >
            <b-tabs content-class="mt-3" class="manager-quote-tab ml-4">
              <b-tab :title="'Licenses'" @click="fetchLicenseDetails()">
                <b-form
                  @submit.prevent="licenceFormSubmitted()"
                  @keydown="licenceForm.onKeydown($event)"
                >
                  <div class="col-md-12 py-0 px-0">
                    <div
                      v-for="(licence, idx) in licenceForm.licences"
                      :key="idx"
                      class="row"
                      style="position:relative;"
                    >
                  <div style="text-align:right;width:100%;">
                  <p
                    v-if="licence.licence_status == 'verified'"
                    style="
                      display: inline-block;
                      background-color: #28a745;
                      color: white;
                      padding: 5px 10px;
                      border-radius: 5px;
                      font-size: 12px;
                    "
                  >
                    Verified
                  </p>
                  <p
                    v-else
                    style="
                      display: inline-block;
                      background-color: #bf1324;
                      color: white;
                      padding: 5px 10px;
                      border-radius: 5px;
                      font-size: 12px;
                    "
                  >
                    Not Verified
                  </p>
                </div>
                      <SvgIcons
                        v-if="idx > 0 && licence.licence_status != 'verified'"
                        icon="insurance-document-close"
                        svgClass="ml-2"
                        style="margin-top: 2px; position: absolute; right: -25"
                        @click.native="deleteLicence(licence, idx)"
                      />
                      <b-col md="6">
                        <b-form-group label="Type of License">
                          <b-form-select
                            v-model="licence.licence_type"
                            :options="licenceTypes"
                            :disabled="licence.licence_status === 'verified'"
                            v-bind:class="{
                              'is-invalid': licence.error.errors.licence_type,
                            }"
                          ></b-form-select>
                          <div
                            class="help-block invalid-feedback"
                            v-if="licence.error.errors.licence_type"
                          >
                            {{ licence.error.errors.licence_type[0] }}
                          </div>
                        </b-form-group>
                      </b-col>

                      <b-col md="6">
                        <b-form-group label="License Number">
                          <b-form-input
                            v-model="licence.licence_number"
                            placeholder="License Number"
                            :disabled="licence.licence_status === 'verified'"
                            v-bind:class="{
                              'is-invalid': licence.error.errors.licence_number,
                            }"
                          ></b-form-input>
                          <div
                            class="help-block invalid-feedback"
                            v-if="licence.error.errors.licence_number"
                          >
                            {{ licence.error.errors.licence_number[0] }}
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <b-form-group
                          class="position-relative tobe file-upload"
                        >
                          <b-form-file
                            placeholder="Upload Documents"
                            multiple
                            :disabled="licence.licence_status === 'verified'"
                            @change="
                              attachLicenceFiles(
                                $event,
                                licence.licence_files,
                                licence.id
                              )
                            "
                            v-bind:class="{
                              'is-invalid': licence.error.errors.licence_files,
                            }"
                          ></b-form-file>

                          <label class="upload-tab">
                            <SvgIcons
                              icon="upload-document-button"
                              width="25px"
                              height="20px"
                              svgClass="upload-docs"
                            />
                            <span class="upload-instruction"
                              >Allowed file types .pdf, .doc. Max file size 5
                              MB.</span
                            >
                          </label>
                          <div>
                            <div
                              v-for="(error, idx) in licence.error.errors"
                              :key="idx"
                            >
                              <span
                                class="help-block invalid-feedback"
                                v-if="idx.startsWith('licence_files')"
                              >
                                {{ error[0] }}
                              </span>
                            </div>
                          </div>
                        </b-form-group>

                        <b-row>
                          <div
                            :disabled="true"
                            class="up-box d-flex mr-2 ml-2"
                            v-for="(file, idx2) in licence.licence_files"
                            :key="'ins-file' + idx + '-' + idx2"
                          >
                            <a :href="file.signed_url" target="_blank"
                              ><p class="mb-0">{{ file.name }}</p></a
                            >
                            <SvgIcons
                              v-if="licence.licence_status != 'verified'"
                              icon="insurance-document-close"
                              svgClass="ml-2"
                              style="margin-top: 2px"
                              @click.native="
                                removeLicenceMedia(file);
                                licence.licence_files.splice(
                                  licence.licence_files.indexOf(file),
                                  1
                                );
                              "
                            />
                          </div>
                        </b-row>
                      </b-col>
                      <hr class="w-100 my-3" />
                    </div>

                    <div class="user-btns">
                      <b-button
                        type="button"
                        variant="outline-primary"
                        class="add-insurance-btn"
                        @click.prevent="addNewLicence"
                        >Add Another Licence</b-button
                      >

                      <b-button
                        :disabled="licenceForm.busy"
                        type="submit"
                        variant="primary"
                        class=""
                        >Submit
                      </b-button>
                    </div>
                  </div>
                </b-form>
              </b-tab>

              <b-tab :title="'Insurance'" @click="fetchInsurancesDetails()">
                <b-form
                  @submit.prevent="insuranceFormSubmitted"
                  @keydown="insuranceForm.onKeydown($event)"
                >
                  <div
                    class="mb-4 mt-4"
                    v-for="(insurance, idx) in insuranceForm.insurances"
                    :key="'ins-' + idx"
                    style="position: relative"
                  >
                       <div style="text-align:right;width:100%;">
                  <p
                    v-if="insurance.insurance_status == 'verified'"
                    style="
                      display: inline-block;
                      background-color: #28a745;
                      color: white;
                      padding: 5px 10px;
                      border-radius: 5px;
                      font-size: 12px;
                    "
                  >
                    Verified
                  </p>
                  <p
                    v-else
                    style="
                      display: inline-block;
                      background-color: #bf1324;
                      color: white;
                      padding: 5px 10px;
                      border-radius: 5px;
                      font-size: 12px;
                    "
                  >
                    Not Verified
                  </p>
                </div>
                    <SvgIcons
                      v-if="idx > 0 && insurance.insurance_status != 'verified'"
                      icon="insurance-document-close"
                      svgClass="ml-2"
                      style="margin-top: 2px; position: absolute; right: -27"
                      @click.native="deleteInsurance(insurance, idx)"
                    />
                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-form-group>
                          <template v-slot:label>
                            Type of Insurance <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                            v-model="insurance.insurance_type"
                            :options="insuranceTypes"
                            :disabled="
                              insurance.insurance_status === 'verified'
                            "
                          ></b-form-select>
                          <div
                            class="help-block invalid-feedback"
                            v-if="insurance.error.errors.insurance_type"
                          >
                            {{ insurance.error.errors.insurance_type[0] }}
                          </div>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group>
                          <template v-slot:label>
                            Policy Number <span class="text-danger">*</span>
                          </template>

                          <b-form-input
                            type="text"
                            v-model="insurance.insurance_policy"
                            :disabled="
                              insurance.insurance_status === 'verified'
                            "
                            v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_policy,
                            }"
                          ></b-form-input>
                          <div
                            class="help-block invalid-feedback"
                            v-if="insurance.error.errors.insurance_policy"
                          >
                            {{ insurance.error.errors.insurance_policy[0] }}
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-form-group class="mr-3">
                          <template v-slot:label> Limit($) </template>
                          <b-form-input
                            type="text"
                            v-model="insurance.insurance_limit"
                            :disabled="
                              insurance.insurance_status === 'verified'
                            "
                            v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_limit,
                            }"
                          ></b-form-input>
                          <div
                            class="help-block invalid-feedback"
                            v-if="insurance.error.errors.insurance_limit"
                          >
                            {{ insurance.error.errors.insurance_limit[0] }}
                          </div>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group>
                          <template v-slot:label> Expiry </template>
                          <date-picker
                            valueType="format"
                            :format="'DD-MM-YYYY'"
                            type="date"
                            :hide-header="true"
                            :disabled="
                              insurance.insurance_status === 'verified'
                            "
                            v-bind:min="minDate"
                            v-model="insurance.insurance_expiry"
                            v-bind:class="{
                              'is-invalid':
                                insurance.error.errors.insurance_expiry,
                            }"
                          ></date-picker>
                          <div
                            class="help-block invalid-feedback"
                            v-if="insurance.error.errors.insurance_expiry"
                          >
                            {{ insurance.error.errors.insurance_expiry[0] }}
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-form-group class="position-relative tobe">
                      <b-form-file
                        :disabled="insurance.insurance_status === 'verified'"
                        placeholder="Upload Documents"
                        multiple
                        @change="
                          attachInsuranceFiles(
                            $event,
                            insurance.insurance_files,
                            insurance.id
                          )
                        "
                        v-bind:class="{
                          'is-invalid': insurance.error.errors.insurance_files,
                        }"
                      >
                      </b-form-file>
                      <label class="upload-tab">
                        <SvgIcons
                          icon="upload-document-button"
                          width="25px"
                          height="20px"
                          svgClass="upload-docs"
                        />

                        <span class="upload-instruction"
                          >Allowed file types .pdf, .doc. Max file size 5
                          MB.</span
                        >
                      </label>
                      <div>
                        <div
                          v-for="(error, idx) in insurance.error.errors"
                          :key="idx"
                        >
                          <span
                            class="help-block invalid-feedback"
                            v-if="idx.startsWith('insurance_files')"
                          >
                            {{ error[0] }}
                          </span>
                        </div>
                      </div>
                    </b-form-group>
                    <b-row>
                      <div
                        class="up-box d-flex mr-2 ml-2"
                        v-for="(file, idx2) in insurance.insurance_files"
                        :key="'ins-file' + idx + '-' + idx2"
                      >
                        <a :href="file.signed_url" target="_blank"
                          ><p class="mb-0">{{ file.name }}</p></a
                        >
                        <SvgIcons
                          v-if="insurance.insurance_status != 'verified'"
                          icon="insurance-document-close"
                          svgClass="ml-2"
                          style="margin-top: 2px"
                          @click.native="
                            removeInsuranceMedia(file);
                            insurance.insurance_files.splice(
                              insurance.insurance_files.indexOf(file),
                              1
                            );
                          "
                        />
                      </div>
                    </b-row>
                    <hr
                      style="margin-top: 1rem; margin-bottom: 1rem"
                      v-if="idx != insuranceForm.insurances.length - 1"
                    />
                  </div>
                  <hr style="margin-top: 1rem; margin-bottom: 1rem" />
                  <!-- <a href="#!" @click.prevent="addNewInsurance" style="color: #000;">+ Add More</a><br/><br/> -->
                  <b-button
                    type="button"
                    variant="outline-primary"
                    class="add-insurance-btn mb-4"
                    @click.prevent="addNewInsurance"
                    >Add Another Insurance</b-button
                  >

                  <b-button
                    :disabled="insuranceForm.busy"
                    type="submit"
                    variant="primary"
                    class="btn-grad float-right"
                    >Submit
                  </b-button>
                </b-form>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import { Form, HasError } from "vform";
import TabsBar from "../includes/TabsBar.vue";
import Swal from "sweetalert2";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import toggleMixin from "../../../../mixins/toggleMixin.js";
import dateFormatMixin from "../../../../mixins/dateFormatMixin.js";
import TabsBarVue from "../includes/TabsBar.vue";

export default {
  props: [],
  components: {
    TabsBar,
    HasError,
    NavBar,
    SvgIcons,
    DatePicker,
  },

  mixins: [toggleMixin, dateFormatMixin],
  data() {
    return {
      licenceForm: new Form({
        licences: [],
      }),
      licenceTypes: [
        { value: "", text: "Choose", disabled: true },
        { value: "trade_work", text: "Trade Work" },
        { value: "security", text: "Security" },
        { value: "asbestos_and_high_risk", text: "Asbestos & High Risk" },
        { value: "pesticide", text: "Pesticide" },
        { value: "fire_and_safety", text: "FPA Australia accreditation" },
      ],
      insuranceForm: new Form({
        insurances: [],
      }),
      insuranceTypes: [
        { value: "", text: "Choose", disabled: true },
        { value: "public-liability", text: "Public Liability" },
        { value: "workers-compensation", text: "Workers Compensation" },
        { value: "professional-indemnity", text: "Professional Indemnity" },
        { value: "other-insurances", text: "Other Insurances" },
      ],
      successMessage: "",
    };
  },
  mounted() {
    //licence
    this.fetchLicenseDetails();

    //Insurance
    this.minExpiryDate();
  },
  computed: {},
  methods: {
    validated(licence_status) {
      if (licence_status == "verified") {
        return true;
      } else {
        return false;
      }
    },
    fetchLicenseDetails() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/license/getDetails", {
          load_licence_media: 1,
        })
        .then((response) => {
          if (response.data.licences.length > 0) {
            this.licenceForm.licences = [];
            response.data.licences.forEach((licence, index) => {
              this.licenceForm.licences.push({
                id: licence.id,
                licence_type: licence.licence_type,
                licence_number: licence.licence_number,
                licence_files: licence.media,
                licence_status: licence.licence_status,
                error: {
                  errors: {},
                },
              });
            });
          }
          this.$root.$data.bsLoader = false;
        })
        .catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },

    opensidebar() {
      let sidebarDetails = document.querySelector(".change-details");
      this.toggleProfile(sidebarDetails);
    },

    licenceFormSubmitted() {
      this.$root.$data.bsLoader = true;
      const orderPromises = this.licenceForm.licences.map((licence, index) => {
        return new Promise((resolve, reject) => {
          var data = new FormData();
          data.append("id", licence.id);
          data.append("licence_type", licence.licence_type);
          data.append("licence_number", licence.licence_number);

          for (var i = 0; i < licence.licence_files.length; i++) {
            if (licence.licence_files[i] instanceof File) {
              data.append("licence_files[]", licence.licence_files[i]);
            }
            // data.append("licence_files[]", licence.licence_files[i]);
          }

          return axios
            .post("api/contractor/license/updateOrCreate2", data, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              this.licenceForm.licences[index].error.errors = {};
              // this.$root.$data.bsLoader = false;
              resolve(licence);
            })
            .catch((error) => {
              if (error.response?.data?.errors) {
                this.licenceForm.errors = error.response.data;
                this.licenceForm.licences[index].error = error.response.data;
              }

              resolve(licence);
            });
        }, Math.random() * 2000);
      });

      Promise.all(orderPromises).then((results) => {
        this.$root.$data.bsLoader = false;
        if (!Object.keys(this.licenceForm.errors.errors).length > 0) {
          Swal.fire({
            title: "License Updated Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        }
      });
    },

    addNewLicence() {
      this.licenceForm.licences.push({
        id: "",
        licence_type: "",
        licence_number: "",
        licence_files: [],
        error: {
          errors: {},
        },
      });
    },

    attachLicenceFiles: function (event, attachFilesTo, licence_id) {
      if (!event.target.files.length) return;
      var input = event.target.files;

      input &&
        _.forEach(input, (file) => {
          attachFilesTo.push(file);
        });
    },

    removeLicenceMedia(file) {
      if (file.uuid) {
        this.$root.$data.bsLoader = true;
        axios
          .post("api/contractor/license/deleteMedia", { file: file.uuid })
          .then((response) => {
            this.$root.$data.bsLoader = false;
            Swal.fire({
              title: "File Deleted Successfully.",
              icon: "success",
              timer: 3000,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
            });
          })
          .catch((err) => {
            this.$root.$data.bsLoader = false;
          });
      }
    },

    deleteLicence(licence, idx) {
      if(licence.id){
        this.$root.$data.bsLoader = true;
        axios
        .post("api/contractor/license/deleteLicense", {
          licence_id: licence.id,
        })
        .then((response) => {
          this.licenceForm.licences.splice(
            this.licenceForm.licences.indexOf(licence),
            1
          );
          this.$root.$data.bsLoader = false;
          Swal.fire({
            title: "Licence Deleted Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        })
        .catch((err) => {
          this.$root.$data.bsLoader = false;
        });
      }else{
        this.licenceForm.licences.splice(idx,1);
      }

    },

    //Insurance
    fetchInsurancesDetails() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/insurance/getDetails", {
          load_insurances_media: 1,
        })
        .then((response) => {
          if (response.data.insurances == "empty") {
            //Redirecting into business page if business is not created
            this.$router.push({
              name: "register-contractor",
              params: { step: 2 },
            });
          } else {
            if (response.data.insurances.length) {
              this.insuranceForm.insurances = [];
              response.data.insurances.forEach((insurance) => {
                this.insuranceForm.insurances.push({
                  id: insurance.id,
                  insurance_type: insurance.insurance_type,
                  insurance_policy: insurance.insurance_policy,
                  insurance_limit: insurance.insurance_limit,
                  insurance_expiry: this.changeDateFormatTo_DD_MM_YYYY(
                    insurance.insurance_expiry
                  ),
                  insurance_files: insurance.media,
                  insurance_status: insurance.insurance_status,
                  error: {
                    errors: {},
                  },
                });
              });
            } else {
              this.addNewInsurance();
            }
          }
          this.$root.$data.bsLoader = false;
        })
        .catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
    addNewInsurance() {
      this.insuranceForm.insurances.push({
        id: "",
        insurance_type: "",
        insurance_policy: "",
        insurance_limit: "",
        insurance_expiry: "",
        insurance_files: [],
        error: {
          errors: {},
        },
      });
    },

    insuranceFormSubmitted() {
      this.$root.$data.bsLoader = true;
      const orderPromises = this.insuranceForm.insurances.map(
        (insurance, index) => {
          return new Promise((resolve, reject) => {
            var data = new FormData();
            data.append("id", insurance.id);
            data.append("insurance_type", insurance.insurance_type);
            data.append("insurance_policy", insurance.insurance_policy);
            data.append("insurance_limit", insurance.insurance_limit);
            data.append("insurance_expiry", insurance.insurance_expiry);

            for (var i = 0; i < insurance.insurance_files.length; i++) {
              if (insurance.insurance_files[i] instanceof File) {
                data.append("insurance_files[]", insurance.insurance_files[i]);
              } else {
                data.append(
                  "previous_insurance_files[]",
                  insurance.insurance_files[i]
                );
              }
            }

            return axios
              .post("api/contractor/insurance/updateOrCreate2", data, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                this.insuranceForm.insurances[index].error.errors = {};
                resolve(insurance);
              })
              .catch((error) => {
                this.insuranceForm.errors = error.response.data;
                if (error.response?.data?.errors) {
                  this.insuranceForm.insurances[index].error =
                    error.response.data;
                }
                resolve(insurance);
              });
          }, Math.random() * 2000);
        }
      );

      Promise.all(orderPromises).then((results) => {
        this.$root.$data.bsLoader = false;
        if (!Object.keys(this.insuranceForm.errors.errors).length > 0) {
          Swal.fire({
            title: "Insurance Data Updated Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        }
      });
    },

    attachInsuranceFiles: function (event, attachFilesTo, insurance_id) {
      if (!event.target.files.length) return;
      var input = event.target.files;

      input &&
        _.forEach(input, (file) => {
          attachFilesTo.push(file);
        });
    },

    minExpiryDate() {
      var date = new Date();
      var dd = date.getDate() + 1;
      var mm = date.getMonth() + 1; //January is 0!
      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var today = yyyy + "-" + mm + "-" + dd;
      this.minDate = today;
    },

    removeInsuranceMedia(file) {
      if (file.uuid) {
        this.$root.$data.bsLoader = true;
        axios
          .post("api/contractor/insurance/deleteMedia", { file: file.uuid })
          .then((response) => {
            this.$root.$data.bsLoader = false;
            Swal.fire({
              title: "File Deleted Successfully.",
              icon: "success",
              timer: 3000,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
            });
          })
          .catch((err) => {
            this.$root.$data.bsLoader = false;
          });
      }
    },

    deleteInsurance(insurance, idx) {
      if(insurance.id){
        this.$root.$data.bsLoader = true;
        insurance &&
          axios
            .post("api/contractor/insurance/deleteInsurance", {
              insurance_id: insurance.id,
            })
            .then((response) => {
              this.insuranceForm.insurances.splice(
                this.insuranceForm.insurances.indexOf(insurance),
                1
              );
              this.$root.$data.bsLoader = false;
              Swal.fire({
                title: "Insurance Deleted Successfully.",
                icon: "success",
                timer: 3000,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
              });
            })
            .catch((err) => {
              this.$root.$data.bsLoader = false;
            });
      }else{
        this.insuranceForm.insurances.splice(idx,1);
      }
    },
  },
};
</script>

<style scoped>
.user-btns {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 5px;
}
</style>
